<template>
  <div>
    <v-card>
      <v-card-text>
        <div class="mt-5">Eventos del {{ start }}</div>
        <v-list class="mt-5">
          <v-list-item-group color="primary">
            <template v-for="(event, key) in eventList">
              <v-list-item :key="key">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ event.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Finaliza el {{ event.end_format }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text color="primary" @click="openDialogEventShow(key)"
                    >editar</v-btn
                  >
                </v-list-item-action>
              </v-list-item>
              <v-divider
                :key="`div${key}`"
                v-if="key != eventList.length - 1"
              />
            </template>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogEventShow" width="600" persistent>
      <event-form
        schema="edit"
        title="EDITAR EVENTO"
        :event="event"
        :start="start"
        :click="click"
        @editEvent="editEvent"
        @deleteEvent="deleteEvent"
        @closeDialogEventShow="closeDialogEventShow"
      />
    </v-dialog>
  </div>
</template>

<script>
import eventForm from "./eventForm.vue";

export default {
  props: ["start", "eventList"],

  components: { eventForm },

  data() {
    return {
      click: 0,
      event: {},
      dialogEventShow: false,
    };
  },

  methods: {
    openDialogEventShow(key) {
      this.click++;
      this.event = this.eventList[key];
      this.dialogEventShow = true;
    },

    closeDialogEventShow() {
      this.dialogEventShow = false;
    },

    editEvent(event) {
      let index = this.eventList.findIndex((e) => e.id == event.id);
      this.eventList.splice(index, 1, event);
      this.$emit("editEventCalendar", event);
    },

    deleteEvent(event) {
      let index = this.eventList.findIndex((e) => e.id == event.id);
      this.eventList.splice(index, 1);
      this.$emit("deleteEventCalendar", event);
    },
  },
};
</script>

<style></style>
